import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Create Organization")
], -1)
const _hoisted_2 = { class: "mb-10 fv-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-3 required" }, "Organization Name", -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-md-6" }
const _hoisted_6 = { class: "fv-row mb-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Phone Number", -1)
const _hoisted_8 = { class: "col-12 col-md-6" }
const _hoisted_9 = { class: "fv-row mb-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Email Address", -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12 col-md-6" }
const _hoisted_13 = { class: "fv-row mb-10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Website", -1)
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = { class: "col-12 col-md-6" }
const _hoisted_17 = { class: "mb-0 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, "Industry", -1)
const _hoisted_19 = { class: "d-flex flex-column justify-content-center mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Selector2 = _resolveComponent("Selector2")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalBase = _resolveComponent("ModalBase")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: "Create Organization",
    size: "modal-lg",
    ref: "modal",
    "is-loading": _ctx.isLoading,
    "loading-text": "Creating Your Organization"
  }, {
    body: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: _normalizeClass(["form-control form-control-lg", {'is-invalid': _ctx.v$.organizationCommand.name.$error}]),
          name: "account_name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.organizationCommand.name) = $event))
        }, null, 2), [
          [_vModelText, _ctx.organizationCommand.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              class: "form-control form-control-lg",
              onMaska: _cache[1] || (_cache[1] = ($event: any) => (_ctx.organizationCommand.phone = $event.target.dataset.maskRawValue)),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orgPhone) = $event)),
              type: "tel"
            }, null, 544), [
              [_directive_maska, `1 (###) ###-####`],
              [_vModelText, _ctx.orgPhone]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              name: "organization_email",
              type: "email",
              class: _normalizeClass(["form-control form-control-lg", {'is-invalid': _ctx.v$.organizationCommand.email.$error}]),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.organizationCommand.email) = $event))
            }, null, 2), [
              [_vModelText, _ctx.organizationCommand.email]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              name: "business_name",
              class: _normalizeClass(["form-control form-control-lg", {'is-invalid': _ctx.v$.organizationCommand.website.$error}]),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.organizationCommand.website) = $event))
            }, null, 2), [
              [_vModelText, _ctx.organizationCommand.website]
            ]),
            (_ctx.v$.organizationCommand.website.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Must be a valid address, starting with https://"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_Selector2, {
              options: _ctx.organizationIndustryOptions,
              modelValue: _ctx.organizationCommand.type,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.organizationCommand.type) = $event))
            }, null, 8, ["options", "modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_Button, {
          "is-loading": _ctx.isLoading,
          onClick: _ctx.add
        }, {
          default: _withCtx(() => [
            _createTextVNode("Create Organization")
          ]),
          _: 1
        }, 8, ["is-loading", "onClick"]),
        _createVNode(_component_Button, {
          onClick: _ctx.closeModal,
          type: "secondary",
          class: "d-md-none mt-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}